import {TOOLTIP_ADD, TOOLTIP_EDIT, TOOLTIP_HIDE, TOOLTIP_REMOVE, TOOLTIP_SHOW} from '../constants/tooltipTypes';

export function tooltipAdd(params) {
  return {
    type: TOOLTIP_ADD,
    payload: params
  };
}

export function tooltipHide(params) {
  return {
    type: TOOLTIP_HIDE,
    payload: params
  };
}

export function tooltipRemove(params) {
  return {
    type: TOOLTIP_REMOVE,
    payload: params
  };
}

export function tooltipShow(params) {
  return {
    type: TOOLTIP_SHOW,
    payload: params
  };
}

export function tooltipEdit(params) {
  return {
    type: TOOLTIP_EDIT,
    payload: params
  };
}



// WEBPACK FOOTER //
// ./app/actions/tooltipActions.js